module.exports = __webpack_public_path__ + "static/media/how_to_get_link.39511f1e.png";